import { type Property } from 'csstype';
import { type PropsWithChildren } from 'react';
import { gridStyle } from '~/_shared/baseComponents/table/table.styles';
import { TableContext } from './table.context';

type TableProps = PropsWithChildren<{
  readonly columnWidths: ReadonlyArray<Property.ColumnWidth>;
  readonly className?: string;
}>;

export const TableComponent = ({
  children,
  columnWidths,
  className,
}: TableProps) => {
  return (
    <div css={gridStyle({ columnWidths })} className={className}>
      <TableContext.Provider value={{ columnCount: columnWidths.length }}>
        {children}
      </TableContext.Provider>
    </div>
  );
};
